export function withDefault(obj, def) {
  if (!obj) return def;
  return obj;
}
export default withDefault;